import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  Button,
} from '@mui/material'
import { useAppStore } from '../../store/useAppStore'
import { useTranslation } from 'react-i18next'

const AlertDialog = () => {
  const alertDialog = useAppStore((state) => state.alertDialog)
  const setAlertDialog = useAppStore((state) => state.setAlertDialog)

  const handleClose = () => {
    setAlertDialog({
      open: false,
      message: alertDialog.message,
      header: alertDialog.header,
    })
  }

  const { t } = useTranslation()

  return (
    <Dialog
      open={!!alertDialog.open}
      onClose={handleClose}
      className={'over-snackbar'}
      PaperProps={{
        sx: {
          width: '90%',
          maxWidth: 280,
          margin: (theme) => theme.spacing(5),
        },
      }}
    >
      <Box sx={{ padding: (theme) => theme.spacing(3, 3, 2.5, 3) }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: '1.125rem',
            lineHeight: '1.3125rem',
          }}
        >
          {alertDialog.header}
        </Typography>
      </Box>
      <DialogContent
        sx={{
          paddingBottom: (theme) => theme.spacing(3),
        }}
      >
        <Typography
          variant={'body1'}
          sx={{
            letterSpacing: 'normal',
          }}
        >
          {alertDialog.message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          {t('common.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AlertDialog
